import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpClient
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService,
              private router: Router,
              private http: HttpClient) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe (
      catchError(e => {
        let errorMessage = '';
        if (e.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${e.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${e.status}\nMessage: ${e.message}`;
        }
        if (e.status === 401) {
            if (this.auth.isAuthenticated()) {
              this.auth.logout();
            }
          }
        if (e.status === 403) {
          this.router.navigate(['/login']);
        }
        return throwError(errorMessage);
      }));
  }
}
